import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ConfigProvider } from 'antd';
import arEG from 'antd/locale/ar_EG';
import enUS from 'antd/locale/en_US';
import { useTranslation } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '../core/auth/AuthContext';
import '../core/i18n';
import { antTheme } from '../core/theme/tokens';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

function AntdProvider({ children }) {
  const { i18n } = useTranslation();
  const locale = i18n.language === 'ar' ? arEG : enUS;
  const direction = i18n.language === 'ar' ? 'rtl' : 'ltr';

  return (
    <ConfigProvider
      locale={locale}
      direction={direction}
      theme={antTheme}
    >
      {children}
    </ConfigProvider>
  );
}

export default function AppProviders({ children }) {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <AntdProvider>{children}</AntdProvider>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
